export default {
  title: 'Modtag nyheder og tilbud via e-mail',
  form: {
    marketing_subscription: {
      label: 'Få eksklusive tilbud, rabatter og opdateringer direkte i din indbakke',
    },
  },
};
